import { Component, Injector, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, Validators, ReactiveFormsModule } from '@angular/forms';
import { ControlValueAccessorDirective } from '@shared/base-classes/control-value-accessor.directive';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { TlkTextInputComponent } from '@itero/ui-toolkit-angular/text-input';

@Component({
	selector: 'rx-license-input',
	template: `
		<tlk-text-input
			[id]="'license-editor'"
			[label]="('DoctorSection.License' | translate) + ':'"
			[required]="true"
			[name]="'license'"
			[autocomplete]="'off'"
			[formControl]="control"
			class="license-editor"
		>
			<ng-container tlk-error>
				<span *ngIf="control.errors?.maxlength" [translate]="'DoctorSection.LicenceInvalidLength'"
					[translateParams]="{maxLength: control.errors.maxlength?.requiredLength}">
				</span>
				<span *ngIf="control.errors?.required && !control.errors?.maxlength" [translate]="'DoctorSection.LicenseIsRequired'">
				</span>
			</ng-container>
		</tlk-text-input>
	`,
	styleUrls: ['./license-input.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: LicenseInputComponent,
			multi: true
		}
	],
	standalone: true,
	imports: [TlkTextInputComponent, ReactiveFormsModule, NgIf, TranslateModule]
})
export class LicenseInputComponent extends ControlValueAccessorDirective<string> implements OnInit {
	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit(): void {
		this.control.setValidators([Validators.required.bind(this), Validators.maxLength(36)]);
	}
}
